var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaundry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "28px",
    viewBox: "0 0 26 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn/amenities/laundry") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn/amenities/laundry",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "laundry-machine-2",
    transform: "translate(-0.000000, 0.000000)",
    fill: "#333333",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.20833333,28 C1.75911908,27.9987135 0.584619809,26.8242143 0.583333333,25.375 L0.583333333,2.625 C0.584619809,1.17578574 1.75911908,0.00128647591 3.20833333,0 L22.4583333,0 C23.9075476,0.00128647591 25.0820469,1.17578574 25.0833333,2.625 L25.0833333,25.375 C25.0820469,26.8242143 23.9075476,27.9987135 22.4583333,28 L3.20833333,28 Z M2.33333333,25.375 C2.33333333,25.858 2.72533333,26.25 3.20833333,26.25 L22.4583333,26.25 C22.9415825,26.25 23.3333333,25.8582492 23.3333333,25.375 L23.3333333,8.75 L2.33333333,8.75 L2.33333333,25.375 Z M23.3333333,7 L23.3333333,2.625 C23.3333333,2.14175084 22.9415825,1.75 22.4583333,1.75 L3.20833333,1.75 C2.72508418,1.75 2.33333333,2.14175084 2.33333333,2.625 L2.33333333,7 L23.3333333,7 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95833333,5.25 C4.47508418,5.25 4.08333333,4.85824916 4.08333333,4.375 C4.08333333,3.89175084 4.47508418,3.5 4.95833333,3.5 L8.45833333,3.5 C8.94158249,3.5 9.33333333,3.89175084 9.33333333,4.375 C9.33333333,4.85824916 8.94158249,5.25 8.45833333,5.25 L4.95833333,5.25 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8333333,24.5 C8.974,24.5 5.83333333,21.3593333 5.83333333,17.5 C5.83333333,13.6406667 8.974,10.5 12.8333333,10.5 C16.6926667,10.5 19.8333333,13.6406667 19.8333333,17.5 C19.8333333,21.3593333 16.6926667,24.5 12.8333333,24.5 Z M12.8333333,12.25 C9.93883333,12.25 7.58333333,14.6055 7.58333333,17.5 C7.58333333,20.3945 9.93883333,22.75 12.8333333,22.75 C15.7278333,22.75 18.0833333,20.3945 18.0833333,17.5 C18.0833333,14.6055 15.7278333,12.25 12.8333333,12.25 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 19.8333333,
    cy: 4.375,
    r: 1.3125
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 14.5833333,
    cy: 4.375,
    r: 1.3125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2083333,18.375 C9.72508418,18.375 9.33333333,17.9832492 9.33333333,17.5 C9.33333333,15.5703333 10.9036667,14 12.8333333,14 C13.3165825,14 13.7083333,14.3917508 13.7083333,14.875 C13.7083333,15.3582492 13.3165825,15.75 12.8333333,15.75 C11.8685,15.75 11.0833333,16.5351667 11.0833333,17.5 C11.0833333,17.9832492 10.6915825,18.375 10.2083333,18.375 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaundry);
export default __webpack_public_path__ + "static/media/laundry.18b3eb68beb9a030714a067b5540dec5.svg";
export { ForwardRef as ReactComponent };